<script>
import HorizontalTopbar from "@/components/horizontal-topbar";
// import HorizontalNav from "@/components/horizontal-nav";
import RightBar from "@/components/right-bar";
import Footer from "@/components/footer";
import NprogressContainer from 'vue-nprogress/src/NprogressContainer'

import { layoutComputed } from "@/state/helpers";

/**
 * Horizontal-layout
 */
export default {
  components: {
    HorizontalTopbar,
    // HorizontalNav,
    Footer,
    NprogressContainer,
    RightBar
  },
  data() {
    return {};
  },
  computed: {
    ...layoutComputed,
  },
  created: () => {
    document.body.setAttribute("data-layout", "horizontal");
    document.body.setAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-sidebar");
    document.body.removeAttribute("data-layout-size");
    document.body.classList.remove("auth-body-bg");
  },
  methods: {
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
    // Always on (every instance, no env flag): the fixed topbar grows with the options an instance opens
    // (news bar, address header bar, wrapped menu, mobile search). A static offset then lets it cover the
    // top of the page — the unpaid / due-date / changed-order alerts first. Measure it and push the
    // content down to just below it instead (no gap on the home page, whose hero sits flush).
    fitUnderTopbar() {
      const bar = document.getElementById("page-topbar");
      const main = this.$refs.mainContent;
      if (!bar || !main) return;
      main.style.setProperty("margin-top", "0px", "important");
      const naturalTop = main.getBoundingClientRect().top + window.scrollY;
      const need = bar.getBoundingClientRect().height + (this.$route.name === "default" ? 0 : 20);
      main.style.setProperty("margin-top", Math.max(0, Math.ceil(need - naturalTop)) + "px", "important");
    },
    // ResizeObserver entry point. Guarded against a feedback loop: pushing the content down can toggle the page
    // scrollbar, which changes the width, which re-wraps the menu, which changes the topbar height again...
    // Only react to a real height change, at most once per frame, and give up after 8 fits in 2 s.
    onTopbarResize(entries) {
      const h = Math.round(entries[0].contentRect.height);
      if (h === this.topbarH) return;
      this.topbarH = h;
      const now = Date.now();
      this.fitTimes = (this.fitTimes || []).filter((t) => now - t < 2000).concat(now);
      if (this.fitTimes.length > 8) {
        if (this.topbarObserver) this.topbarObserver.disconnect();
        return;
      }
      cancelAnimationFrame(this.fitFrame);
      this.fitFrame = requestAnimationFrame(() => this.fitUnderTopbar());
    },
  },
  watch: {
    $route() {
      this.$nextTick(this.fitUnderTopbar);
    },
  },
  beforeDestroy() {
    if (this.topbarObserver) this.topbarObserver.disconnect();
    window.removeEventListener("resize", this.fitUnderTopbar);
  },
  mounted() {
    this.$nextTick(this.fitUnderTopbar);
    const bar = document.getElementById("page-topbar");
    if (bar && window.ResizeObserver) {
      this.topbarObserver = new ResizeObserver(this.onTopbarResize);
      this.topbarObserver.observe(bar);
    }
    window.addEventListener("resize", this.fitUnderTopbar);
      
    document.body.style.background=  this.$route.name === 'default' ? '#fff' : '#f8f8fb';
    
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
};
</script>

<style lang="scss">
  
  #nprogress .bar {
    background: $primary;// #f2b44d;
    height: 4px;
  }

  #nprogress .spinner-icon {
  border: solid 4px transparent;
  border-top-color: $primary;
  border-left-color: $primary;
  }

  #nprogress .peg {
  box-shadow: 0 0 10px grey, 0 0 5px grey;
  //box-shadow: 0 0 10px #f46a6a, 0 0 5px #f46a6a;
  opacity: 1.0;
  }

  @media all and (max-width: 1024px) {
    .container-fluid {
        padding-left: 20px !important;
        padding-right: 20px !important;
    } 
  }

</style>

<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <!-- Begin page -->
    <div id="layout-wrapper">
      <HorizontalTopbar :type="topbar" :width="layoutWidth" />
      <!-- <HorizontalNav /> -->
      <vue-snotify></vue-snotify>
      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div ref="mainContent" class="main-content " :class="this.$route.name === 'default' ? '' : 'mt-5'">
        <div class="page-content nprogress-container" :class="this.$route.name === 'default' ? 'page-content-full-width' : 'page-content'">
        <nprogress-container></nprogress-container>
        <!-- Start Content-->
        <div id="containerfluid" :class="this.$route.name === 'default' ? 'container-fluid-full-width' : 'container-fluid'">
          <slot />
          </div>
        </div>
        <!-- End Page-content -->
        <Footer />
      </div>
      <!-- end main content-->
    </div>
    <!-- END layout-wrapper -->
    <RightBar />
  </div>
</template>